import { ProductInput } from '@vy/types';
import { formatPeriod, Period } from '@vy/utils';
import { buildProductPeriodsData } from '../../../../../../contract/contract-page-components/ContractContent/ContractPhasesSection/contract-phases-section-utils/product-periods-builder';
import { useMemo } from 'react';
import { useDialog } from '../../../../../../../hooks/use-dialog';
import { Button, Stack, Typography } from '@mui/material';
import { VyDialog } from '../../../../../../../components/new-design/feedback/VyDialog';
import { ContractPhasesTimelineContainer } from '../../../../../../contract/contract-page-components/ContractContent/ContractPhasesSection/ContractPhasesTimeline/ContractPhasesTimelineContainer';
import { ContractProductsTimelineRowBar } from '../../../../../../contract/contract-page-components/ContractContent/ContractPhasesSection/ContractPhasesTimeline/ContractProductsTimelineRowBar';
import { VyIcon } from '@vy/ui-design-system';

type ProductTimelineChartDialogProps = {
  contractPeriod: Period;
  products: ProductInput[];
};

export const ProductTimelineChartDialog: React.FC<ProductTimelineChartDialogProps> = ({
  contractPeriod,
  products,
}) => {
  const { handleClose, handleOpen, isDialogOpen } = useDialog();

  const timelineChartData = useMemo(() => {
    return buildProductPeriodsData(contractPeriod, products);
  }, [contractPeriod, products]);

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        sx={{ width: '130px' }}
        startIcon={<VyIcon icon="InfoLines" />}
        onClick={handleOpen}
      >
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: 400
          }}>
          See Timeline
        </Typography>
      </Button>
      <VyDialog
        open={isDialogOpen}
        onClose={handleClose}
        label={
          <Stack
            direction={'row'}
            sx={{
              justifyContent: 'space-between',
              width: '800px',
              gap: 1
            }}>
            <Typography variant="h6">Product Timeline</Typography>
            <Stack
              direction="row"
              sx={{
                gap: 2,
                justifyContent: 'end',
                alignItems: 'center',
                paddingRight: 4
              }}>
              <Stack
                direction="row"
                sx={{
                  gap: 1,
                  alignItems: 'center'
                }}>
                <Typography>{'Fixed'}</Typography>
                <VyIcon icon={'RectangleHollow'} />
              </Stack>
              <Stack
                direction="row"
                sx={{
                  gap: 1,
                  alignItems: 'center'
                }}>
                <Typography>{'Usage based'}</Typography>
                <VyIcon icon={'RectangleLined'} />
              </Stack>
            </Stack>
          </Stack>
        }
        ctaText="OK"
        disableDividers
        fullWidth
        maxWidth="md"
        ctaButtonProps={{ onClick: handleClose }}
        dialogContentProps={{ style: { padding: 0, maxHeight: '360px', width: '100%' } }}
        dialogTitleProps={{ style: { padding: '12px 24px 24px 24px' } }}
        labelDescription={`Contract Term: ${formatPeriod(contractPeriod)}`}
      >
        <div className="h-full w-full py-1">
          <ContractPhasesTimelineContainer
            barWidthFull
            contractLength={contractPeriod}
            chartData={timelineChartData}
            BarComponent={ContractProductsTimelineRowBar}
          />
        </div>
      </VyDialog>
    </>
  );
};
